import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  AppState,
  CategoryFilterOption,
  ContractTypeOption,
  FilterState,
  RadiusFilterOption,
  Region,
  SubcategoryOptionsMap,
} from '@immosky/types';
import {
  availableRadiusOptions,
  removeRegionFilter,
  resetRegionFilter,
  selectFilterState,
  setContractTypeFilter,
  setMainCategoryFilter,
  setSubcategoryFilter,
} from '@immosky/object-search-filter';

@Component({
  selector: 'app-desktop-step-one',
  templateUrl: './desktop-step-one.component.html',
  styleUrls: ['./desktop-step-one.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopStepOneComponent {
  filterState!: FilterState;

  radiusOptions: RadiusFilterOption[] = availableRadiusOptions;
  displaySubcategory = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.store
      .pipe(select(selectFilterState))
      .subscribe((filterState: FilterState) => {
        this.filterState = filterState;

        this.displaySubcategory = this.filterState.category.sub.isDisplayed;

        this.cdRef.markForCheck();
      });
  }

  onContractTypeChange(filter: ContractTypeOption) {
    this.store.dispatch(
      setContractTypeFilter({
        filter,
      })
    );
  }

  onCategoryChange(filter: CategoryFilterOption) {
    this.store.dispatch(
      setMainCategoryFilter({
        filter,
      })
    );
  }

  onSubcategoryChange(filter: SubcategoryOptionsMap) {
    this.store.dispatch(
      setSubcategoryFilter({
        filter,
      })
    );
  }

  trackByRegion(index: number, region: Region) {
    return region.id;
  }

  removeRegionFilter(region: Region) {
    this.store.dispatch(
      removeRegionFilter({
        region,
      })
    );
  }

  resetAllRegions() {
    this.store.dispatch(resetRegionFilter());
  }

  get isCategoryActive(): boolean {
    return this.filterState.category.main.isActive;
  }

  get regions(): Region[] {
    return this.filterState.region.regions;
  }
}
